import { MultipleSelectComponent } from 'src/app/components/multiple-select/multiple-select.component';
import {
    IQueryContext,
    IQueryContextDatasourceColumn,
} from 'src/app/services/query-context/models/IQueryContext';
import { BQSqlFunctionHelper } from 'src/app/utils/datasource-sql-map/bq-sql-function-helper';
import { DatePickerSqlTokensCompiler } from 'src/app/utils/datasource-sql-map/date-picker-sql-tokens-compiler';
import {
    multipleSelectComponentCompileSQLTokens,
    segmentContainerIdCompileSQLTokens,
} from 'src/app/utils/datasource-sql-map/utils';
import { GcpProjectId } from 'src/app/utils/gcp-project-id.model';
import { buildSplitGroupSQL, buildWhereSQL } from 'src/app/utils/query/sql';
import { sqlDateTrunc } from 'src/app/utils/sql';
import {
    ICompiledSQLTokens,
    IDatasourceSQLMap,
    mergeSqlTokensArray,
} from '../../../../utils/datasource-sql-map/datasource';

export class BiVizDashboardRetention {
    public static sqlMap: IDatasourceSQLMap = {
        dataset: 'bi_viz',
        tableId: 'dashboard_retention',
        columns: {
            FIRST_SESSION_DATE: {
                columnId: 'FIRST_SESSION_DATE',
                columnSQL: 'first_session_date',
                compileSQLTokens: (state) => {
                    return DatePickerSqlTokensCompiler.compileTokens(
                        'first_session_date',
                        state
                    );
                },
            },
            FIRST_GEO_COUNTRY_EU: {
                columnId: 'FIRST_GEO_COUNTRY_EU',
                columnSQL: 'user_dim.first_geo.country_european_union',
                compileSQLTokens: (state) => {
                    return multipleSelectComponentCompileSQLTokens(
                        'user_dim.first_geo.country_european_union',
                        state
                    );
                },
            },
            FIRST_GEO_COUNTRY_TIER: {
                columnId: 'FIRST_GEO_COUNTRY_TIER',
                columnSQL: 'user_dim.first_geo.country_tier_label',
                compileSQLTokens: (state) => {
                    return multipleSelectComponentCompileSQLTokens(
                        'user_dim.first_geo.country_tier_label',
                        state
                    );
                },
            },
            FIRST_GEO_COUNTRY: {
                columnId: 'FIRST_GEO_COUNTRY',
                columnSQL: 'user_dim.first_geo.unified_country',
                compileSQLTokens: (state) => {
                    return multipleSelectComponentCompileSQLTokens(
                        'user_dim.first_geo.unified_country',
                        state
                    );
                },
            },
            REVENUE_PAYER: {
                columnId: 'REVENUE_PAYER',
                columnSQL: 'user_dim.revenue.badge',
                compileSQLTokens: (state) => {
                    return multipleSelectComponentCompileSQLTokens(
                        'user_dim.revenue.badge',
                        state
                    );
                },
            },
            REVENUE_BADGE: {
                columnId: 'REVENUE_BADGE',
                columnSQL: 'user_dim.revenue.badge',
                compileSQLTokens: (state) => {
                    return multipleSelectComponentCompileSQLTokens(
                        'user_dim.revenue.badge',
                        state
                    );
                },
            },
            FIRST_APP_VERSION: {
                columnId: 'FIRST_APP_VERSION',
                columnSQL: 'user_dim.first_app.version',
                compileSQLTokens: (state) => {
                    return multipleSelectComponentCompileSQLTokens(
                        'user_dim.first_app.version',
                        state
                    );
                },
            },
            FIRST_APP_VERSION_GROUP_MINOR: {
                columnId: 'FIRST_APP_VERSION_GROUP_MINOR',
                columnSQL: `${BQSqlFunctionHelper.getCallSqlStatement(
                    BQSqlFunctionHelper.VERSION_HIERARCHY,
                    ['user_dim.first_app.version']
                )}.minor`,
                compileSQLTokens: (state) => {
                    return multipleSelectComponentCompileSQLTokens(
                        `${BQSqlFunctionHelper.getCallSqlStatement(
                            BQSqlFunctionHelper.VERSION_HIERARCHY,
                            ['user_dim.first_app.version']
                        )}.minor`,
                        state
                    );
                },
            },
            FIRST_ATTRIBUTION_UNIFIED_TRAFFIC: {
                columnId: 'FIRST_ATTRIBUTION_UNIFIED_TRAFFIC',
                columnSQL: 'user_dim.first_attribution.unified_traffic',
                compileSQLTokens: (state) => {
                    return multipleSelectComponentCompileSQLTokens(
                        'user_dim.first_attribution.unified_traffic',
                        state
                    );
                },
            },
            FIRST_ATTRIBUTION_UNIFIED_NETWORK: {
                columnId: 'FIRST_ATTRIBUTION_UNIFIED_NETWORK',
                columnSQL: 'user_dim.first_attribution.unified_network',
                compileSQLTokens: (state) => {
                    return multipleSelectComponentCompileSQLTokens(
                        'user_dim.first_attribution.unified_network',
                        state
                    );
                },
            },
            FIRST_ATTRIBUTION_CAMPAIGN_ACTIVE: {
                columnId: 'FIRST_ATTRIBUTION_CAMPAIGN_ACTIVE',
                columnSQL: 'active_campaign',
                compileSQLTokens: (state) => {
                    return multipleSelectComponentCompileSQLTokens(
                        'user_dim.first_attribution.active_campaign',
                        state,
                        MultipleSelectComponent.toBooleanSQL
                    );
                },
            },
            FIRST_ATTRIBUTION_UNIFIED_CAMPAIGN: {
                columnId: 'FIRST_ATTRIBUTION_UNIFIED_CAMPAIGN',
                columnSQL: 'user_dim.first_attribution.unified_campaign',
                compileSQLTokens: (state) => {
                    return multipleSelectComponentCompileSQLTokens(
                        'user_dim.first_attribution.unified_campaign',
                        state
                    );
                },
            },
            FIRST_ATTRIBUTION_AD: {
                columnId: 'FIRST_ATTRIBUTION_AD',
                columnSQL: 'user_dim.first_attribution.unified_ad',
                compileSQLTokens: (state) => {
                    return multipleSelectComponentCompileSQLTokens(
                        'user_dim.first_attribution.unified_ad',
                        state
                    );
                },
            },
            FIRST_ATTRIBUTION_AD_LENGTH_S: {
                columnId: 'FIRST_ATTRIBUTION_AD_LENGTH_S',
                columnSQL: 'user_dim.first_attribution.unified_ad_dim.length_s',
                compileSQLTokens: (state) => {
                    return multipleSelectComponentCompileSQLTokens(
                        'user_dim.first_attribution.unified_ad_dim.length_s',
                        state
                    );
                },
            },
            FIRST_ATTRIBUTION_AD_SIZE: {
                columnId: 'FIRST_ATTRIBUTION_AD_SIZE',
                columnSQL: 'user_dim.first_attribution.unified_ad_dim.size',
                compileSQLTokens: (state) => {
                    return multipleSelectComponentCompileSQLTokens(
                        'user_dim.first_attribution.unified_ad_dim.size',
                        state
                    );
                },
            },
            FIRST_ATTRIBUTION_AD_ASPECT_RATIO: {
                columnId: 'FIRST_ATTRIBUTION_AD_ASPECT_RATIO',
                columnSQL:
                    'user_dim.first_attribution.unified_ad_dim.aspect_ratio',
                compileSQLTokens: (state) => {
                    return multipleSelectComponentCompileSQLTokens(
                        'user_dim.first_attribution.unified_ad_dim.aspect_ratio',
                        state
                    );
                },
            },
            FIRST_ATTRIBUTION_AD_TYPE: {
                columnId: 'FIRST_ATTRIBUTION_AD_TYPE',
                columnSQL: 'user_dim.first_attribution.unified_ad_dim.type',
                compileSQLTokens: (state) => {
                    return multipleSelectComponentCompileSQLTokens(
                        'user_dim.first_attribution.unified_ad_dim.type',
                        state
                    );
                },
            },
            FIRST_ATTRIBUTION_AD_THEME: {
                columnId: 'FIRST_ATTRIBUTION_AD_THEME',
                columnSQL: 'user_dim.first_attribution.unified_ad_dim.theme',
                compileSQLTokens: (state) => {
                    return multipleSelectComponentCompileSQLTokens(
                        'user_dim.first_attribution.unified_ad_dim.theme',
                        state
                    );
                },
            },
            FIRST_ATTRIBUTION_AD_VERSION: {
                columnId: 'FIRST_ATTRIBUTION_AD_VERSION',
                columnSQL: 'user_dim.first_attribution.unified_ad_dim.version',
                compileSQLTokens: (state) => {
                    return multipleSelectComponentCompileSQLTokens(
                        'user_dim.first_attribution.unified_ad_dim.version',
                        state
                    );
                },
            },
            SEGMENT: {
                columnId: 'SEGMENT',
                columnSQL: 'segments',
                compileSQLTokens: segmentContainerIdCompileSQLTokens,
            },
            SEGMENT_EXCLUDE: {
                columnId: 'SEGMENT_EXCLUDE',
                columnSQL: 'segments',
                compileSQLTokens: segmentContainerIdCompileSQLTokens,
            },
        },
    };

    // compile sql statements specific for this datasource
    public static compileSQLStatements(
        supportedDatasourceColumns: IQueryContextDatasourceColumn[],
        queryContextSettings: IQueryContext['settings'],
        options: { gcpProjectId: GcpProjectId },
        customCompiledSqlTokens?: Partial<ICompiledSQLTokens>
    ) {
        const dateTrunc = queryContextSettings.dateAggregation
            ? sqlDateTrunc(
                  'first_session_date',
                  queryContextSettings.dateAggregation
              )
            : `first_session_date`;

        // if app_version is present in QueryContext
        // const is_in_context_app_version =
        //     supportedDatasourceColumns.findIndex(
        //         (dsCol) => dsCol.id === 'ACTIVITY_APP_VERSION'
        //     ) != -1;

        // if segment_container_id is present in splits or filters
        const is_in_context_segment =
            supportedDatasourceColumns.findIndex(
                (dsCol) => dsCol.id === 'SEGMENT'
            ) != -1;

        const sqlTokensArray: Partial<ICompiledSQLTokens>[] =
            supportedDatasourceColumns.map((dsCol) => {
                return this.sqlMap.columns[dsCol.id]!.compileSQLTokens!(
                    dsCol.state,
                    options
                );
            });

        // merge tokens into single deduplicated object of type ICompiledSQLTokens
        const sqlTokens: ICompiledSQLTokens =
            mergeSqlTokensArray(sqlTokensArray);

        // unnest app_version_activity if app_version is present in splits or filters
        // TODO to powinno być rozwiązane na poziomie datasource, gdzie compileSQL zwróci atrybut join, z treścią `, UNNEST...`

        const splitSelect: string = buildSplitGroupSQL(sqlTokens.split_group);
        const splitGroupName = 'split_group';
        const splitGroupBy = splitSelect ? `${splitGroupName}, ` : '';
        // const countStarOrDistinctProperId = splitSelect
        //     ? 'COUNT(DISTINCT proper_id)'
        //     : 'COUNT(*)';
        // const unnestDatasourceColumn =
        //     sqlTokens.unnestDatasourceColumn.join('\n');
        const where: string = buildWhereSQL([
            ...sqlTokens.where,
            ...(customCompiledSqlTokens?.where ?? []),
        ]);
        const join: string = sqlTokens.join.join('\n');
        // const windowTotal = splitGroupBy ? 'PARTITION BY split_group' : '';
        const windowRunning = splitGroupBy
            ? 'PARTITION BY split_group ORDER BY day_no'
            : 'ORDER BY day_no';

        return {
            dateTrunc,
            splitSelect,
            splitGroupName,
            splitGroupBy,
            where,
            join,
            windowRunning,
        };
    }
}
